import {Component, ElementRef, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {AuthState} from '@shared/store/auth/auth.state';
import {Observable} from 'rxjs';
import {FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslationService} from '@shared/services/translation.service';
import {LoginExternalInvitation} from '@shared/store/auth/auth.actions';
import {ExternalLoginService} from '@shared/services/external-login.service';

@Component({
    selector: 'saf-external-invitation-login',
    templateUrl: './external-invitation-login.component.html',
    styleUrls: ['./external-invitation-login.component.scss'],
    standalone: false
})
export class ExternalInvitationLoginComponent implements OnInit {
  @Select(AuthState.loading) loading$: Observable<boolean>;
  @ViewChildren('otpInput') inputs!: QueryList<ElementRef>;
  fields = [1, 2, 3, 4, 5, 6];
  formGroup: FormGroup;
  externalEmployeeId: number;
  email: string;
  securityCode: number;

  constructor(
    private externalLoginService: ExternalLoginService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private router: Router,
    private store: Store,
    private translationService: TranslationService,
  ) { }

  ngOnInit(): void {
    this.buildForm();
    this.getParams();
  }

  ngAfterViewInit(): void {
    setTimeout(() => { const firstInput = this.inputs.first?.nativeElement; firstInput?.focus(); });
  }

  getParams() {
    this.route.queryParams.subscribe(params => {
      this.externalEmployeeId = params['externalEmployeeId'];
      this.email = params['email'];

      this.getInvitationLink();
    });
  }

  getInvitationLink() {
    const params = {
      externalEmployeeId: this.externalEmployeeId,
      email: this.email
    };
    this.externalLoginService.getInvitationLink(params).subscribe(data => {
      if ('success' in data && !data.success) {
        this.snackBar.open(this.translationService.translate(this.getFailureReason(data.failureReason)), '', { duration: 5000 });
      }
      if (data.invitationSend) {
        this.snackBar.open(this.translationService.translate('SecurityCodeHasBeenSentToYourEmail'), '', { duration: 5000 });
      }
      // this.invitationId = data.id;
      // this.externalCompanyEmployeeService.getSecurityCode(this.invitationId).subscribe(result => {
      //   console.log('securityCode', result);
      //   if (!result.success) {
      //     this.translationService.translate('maxNumberOfSecurityCodesReached');
      //   }
      // });
    });
  }

  getFailureReason(failureReason: string) {
    switch (failureReason) {
      case 'NoInvitationsFound': return 'NoInvitationsFound';
      case 'maxNumberOfSecurityCodesReached': return 'maxNumberOfSecurityCodesReached';
      case 'SecurityCodeInvalid': return 'SecurityCodeInvalid';
      case 'ExternalEmployeeEmailNoMatch': return 'ExternalEmployeeEmailNoMatch';
      case 'ExternalEmployeeNotFound': return 'ExternalEmployeeNotFound';
      case 'MissingExternalEmployeeIdOrEmail': return 'MissingExternalEmployeeIdOrEmail';
      case 'MissingExternalEmployeeIdOrEmailorSecurityCode': return 'MissingExternalEmployeeIdOrEmailorSecurityCode';
    }
  }

  buildForm() {
    this.formGroup = new FormGroup({
      field1: new FormControl(''),
      field2: new FormControl(''),
      field3: new FormControl(''),
      field4: new FormControl(''),
      field5: new FormControl(''),
      field6: new FormControl('')
    });
  }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Nur Zahlen erlauben
    if (!/^[0-9]$/.test(value)) {
      input.value = '';
      this.formGroup.get('field' + index)?.setValue(value);
      return;
    }

    // Automatisch zum nächsten Feld
    if (value && index < this.fields.length) {
      const nextInput = this.inputs.toArray()[index].nativeElement;
      nextInput.focus();
    }

    if (index === this.fields.length) {
      this.securityCode = Number(Object.values(this.formGroup.value).join(''));
      this.onSubmit();
    }
  }

  onSubmit() {
    const params = {
      externalEmployeeId: this.externalEmployeeId,
      email: this.email,
      securityCode: this.securityCode
    };
    this.store.dispatch(new LoginExternalInvitation(params)).subscribe(result => {
      // TODO check why result not works
      // if (result) {
      //   this.snackBar.open(
      //     this.translationService.translate(this.getFailureReason(result.userDetail.errorMessage)),
      //     '',
      //     { duration: 5000 }
      //   );
      //   this.formGroup.reset();
      //   this.inputs.toArray()[0].nativeElement.focus();
      // }
    });
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !input.value && index > 1) {
      const prevInput = this.inputs.toArray()[index - 2].nativeElement;
      prevInput.focus();
    }
  }

}
